'use client';

import useUser from '@alltrails/context/hooks/useUser';
import { isSubscriber } from '@alltrails/context/utils/isSubscriber';
import ToutSection from '../ToutSection';
import reiPartnershipLogosSrc from './AllTrails-REI-Partnership-Logos.svg';
import reiToutDesktopFreeSrc from './REI-Homepage-Desktop-Free.avif';
import reiToutDesktopSrc from './REI-Homepage-Desktop.avif';
import reiToutMobileFreeSrc from './REI-Homepage-Mobile-Free.avif';
import reiToutMobileSrc from './REI-Homepage-Mobile.avif';
// Design: https://www.figma.com/design/J5mdYuYnLpu18826sqniOQ/REI-x-AllTrails?node-id=287-473

const ReiTout = () => {
  const user = useUser();
  const reiToutLink = '/rei';
  const reiToutNewsroomLink = '/press/alltrails-and-rei-introduce-partnership';
  const reiAltText = 'A person holds their cellphone while hiking a trail using AllTrails.';

  const { images, altText, titleText, subtitleText, buttonText, buttonLink } =
    isSubscriber(user) || !user
      ? {
          images: { mobile: reiToutMobileSrc, desktop: reiToutDesktopSrc },
          altText: reiAltText,
          titleText: 'A partnership built for adventure',
          subtitleText:
            'REI and AllTrails share a passion for getting people outdoors and caring for wild places. Now we’re making that easier than ever for our members.',
          buttonText: 'Learn more',
          buttonLink: reiToutNewsroomLink
        }
      : {
          images: { mobile: reiToutMobileFreeSrc, desktop: reiToutDesktopFreeSrc },
          altText: reiAltText,
          titleText: 'New! REI Co-op members get exclusive prices.',
          subtitleText: 'Your favorite outfitter 🤝 your favorite app. Now REI members can save big on an AllTrails Plus or Peak membership.',
          buttonText: 'Get started',
          buttonLink: reiToutLink
        };

  return (
    <ToutSection
      altText={altText}
      buttonProps={{ linkInfo: { href: buttonLink } }}
      buttonText={buttonText}
      contentLayout="wide"
      desktopImage={images.desktop}
      mobileImage={images.mobile}
      subtitle={subtitleText}
      title={titleText}
      logoAltText="AllTrails and REI logos"
      logoSrc={reiPartnershipLogosSrc}
    />
  );
};

export default ReiTout;
